import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { FormController, StrongText, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import {
   VisitSettlementFormTab,
   VisitSettlementFormTabLoader,
} from '../../../visitSettlement/extensions/visitForm/VisitSettlementFormTab';
import { visitSettlementTranslationKeys } from '../../../visitSettlement/translations';
import { VisitFormController } from '../../form/visitForm.types';

type VisitSettlementFieldProps = {
   readonly controller: VisitFormController;
   readonly visit: Visit;
};

export const VisitSettlementField = (props: VisitSettlementFieldProps): JSX.Element | null => {
   const performingPrivateMedicalServicesAvailable = protectFeature('performingPrivateMedicalServices');

   if (!performingPrivateMedicalServicesAvailable) {
      return null;
   }

   return (
      <StyledFlex direction={'column'} gap={4}>
         <StrongText testId={'visitSettlementLabel'}>
            <Translate>{visitSettlementTranslationKeys.shared.medicalServices.list.heading}</Translate>
         </StrongText>
         <FormController controller={props.controller.register('visitSettlement')} defaultValue={null} />
         <FormController controller={props.controller.register('visitSettlement.id')} defaultValue={null} />
         <FormController
            controller={props.controller.register('visitSettlement.priceChangeReason')}
            defaultValue={null}
         />
         <FormController controller={props.controller.register('visitSettlement.editable')} defaultValue={null} />
         <FormController
            controller={props.controller.register('visitSettlement.ownedByCurrentUser')}
            defaultValue={null}
         />
         <VisitSettlementFormTabLoader appointmentId={props.visit.appointmentId} controller={props.controller}>
            {({ adjustmentBy }) => (
               <VisitSettlementFormTab
                  register={props.controller.register}
                  control={props.controller.control}
                  practitionerId={props.visit.practitionerId.asNumber()}
                  appointmentId={props.visit.appointmentId}
                  adjustmentBy={adjustmentBy}
               />
            )}
         </VisitSettlementFormTabLoader>
      </StyledFlex>
   );
};
